import { render } from "./AssignEmailBox.vue?vue&type=template&id=9b468bea&scoped=true"
import script from "./AssignEmailBox.vue?vue&type=script&lang=js"
export * from "./AssignEmailBox.vue?vue&type=script&lang=js"

import "./AssignEmailBox.vue?vue&type=style&index=0&id=9b468bea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b468bea"]])

export default __exports__